/**
 * Beloved — Daily verse service
 *
 * Thin wrapper around the daily scripture rotation in `src/data/verses.js`.
 * Adds a stable `id` so the verse can be saved and reopened like any other
 * saved item.
 */

import { getVerseOfDay } from '../data/verses';

/**
 * Get today's scripture (or the scripture for a given date), with a stable id.
 *
 * @param {Date} [date] the date to look up (defaults to today)
 * @returns {{id: string, month: number, day: number, ref: string, text: string, reflection: string}}
 */
export function getDailyVerse(date = new Date()) {
  const verse = getVerseOfDay(date);
  return { ...verse, id: `verse-${verse.month}-${verse.day}` };
}

export default getDailyVerse;
